module.exports = require('./ThemeFromPeRootStoreWrapper')
